// Registry of incentivation sources. Add a new source by appending a definition here.
import type { IncentivationSourceDefinition } from '../types'
import { helpKey } from '../../help'
import { IncentivationSourceType, type ManualActionIncentivationSourceModel } from './types'
import ManualActionSourceEditor from '@/pages/action-modules/editor/incentivation-tab/sources/ManualActionSourceEditor'

export const incentivationSources: IncentivationSourceDefinition[] = [
  {
    nameKey: 'incentivationSource.manualAction.name',
    helpKey: helpKey('incentivationSourceManualAction'),
    type: IncentivationSourceType.ManualActionIncentivationSource,
    defaultValue: {
      type: IncentivationSourceType.ManualActionIncentivationSource,
      canBeCompletedByEmployeeUser: true,
      canBulkUploadIncentivationData: false,
    } as ManualActionIncentivationSourceModel,
    editor: props => <ManualActionSourceEditor {...props} />,
  },
]
